angular.module('rjmNg.directives').directive "signupChannelsGoogleAnalytics", [
  () ->
    restrict: "E"
    templateUrl: "directive.signupChannelsGoogleAnalytics.html"
    replace: false
    controllerAs: "view"
    bindToController: true
    scope: {}
    controller: [
      "$clientUrl"
      "$location"
      "$routeParams"
      "$url"
      "$window"
      "appRoute"
      "Google"
      "InputConnections"
      "notification"
      (
        $clientUrl
        $location
        $routeParams
        $url
        $window
        appRoute
        Google
        InputConnections
        notification
      ) ->

        view = @

        _code = null
        _feature = 'Analytics'
        _nextStepUrl = appRoute("/magento/connect/success")
        _refresh_token = null

        _InputConnectionsInstance = InputConnections($routeParams.clientId)

        _clientId = $routeParams.clientId
        _GoogleInstance = Google(_clientId)

        view.hasSelectedProfile = false;
        view.loading = false;
        view.lockImgUrl = $url('') + '/images/lock.png';
        view.saveDisabled = true

        _getSelected = () ->
          if(view.profiles && view.profiles.length > 0)
            result = view.profiles.filter((prof) -> prof.isSelected)
            if(result.length > 0)
              result = result[0]
            else
              result = false
          return result

        _handleError = (message) ->
          view.loading = false
          notification.clear("global")
          notification.error("Something went wrong.", message, "global")
        
        _handleWarning = (message) ->
          notification.clear("global")
          notification.warning("Warning.", message, "global", null, 10)

        _navigateToNextStep = () ->
          $location.path(_nextStepUrl)

        _saveConnection = () ->
          selectedProf = _getSelected()
          if(!selectedProf)
            _handleWarning("Please select at least one Google Ads profile for the integration.")
          else
            connInfo = {
              name: name
              token: _refresh_token
              profileId: selectedProf.id
              feature: _feature
              connectionIdToReauth: null
              relatedConnectionIdsToReauth: null
              webPropertyId: selectedProf.webPropertyId
            }
            _GoogleInstance.save(connInfo).then((success) ->
              view.loading = false
              _navigateToNextStep()
            , (error) ->
              _handleError('Error saving connection')
              view.hasAuthorized = false
              view.loading = false
            )
        
        _testFailed = () ->
          if(confirm('It doesn’t look like there is any data that Adobe Commerce Intelligence can access in
            this Google Analytics profile. Please make sure that you’ve selected
            the right profile and that the credentials you’ve supplied have
            appropriate access. Do you wish to save the connection anyway?'))
            _saveConnection()
          else
            view.loading = false


        view.saveAndAuth = () ->
          $window.location = $clientUrl('/google/authorize?feature=Analytics')
        
        view.saveProfile = () ->
          view.loading = true
          selectedProf = _getSelected()
          if(!selectedProf)
            _handleWarning("Please select at least one Google Ads profile for the integration.")
          else
            view.loading = true
            _GoogleInstance.testConnection(
              token: _refresh_token
              profileId: selectedProf.id
              feature: _feature
            ).then((response) ->
              if response.data.containsRows
                _saveConnection()
              else
                _testFailed()
            ,(error) ->
                _testFailed()
            )

        view.selectedChanged = (id) ->
          view.profiles.map((prof) ->
            prof.isSelected = prof.id is id
            view.saveDisabled = false
          )
        
        view.skipAnalytics = () ->
          _navigateToNextStep()

        view.$postLink = () ->
          view.hasAuthorized = false
          view.loading = true
          _code = $routeParams.code || null
          _InputConnectionsInstance.get().then((response) ->
            gaConnections = response.filter((connection) ->
              connection.type is 'google_analytics'
            )
            if (gaConnections.length)
              view.loading = false
              _navigateToNextStep()
            else
              if(_code)
                _GoogleInstance.getAccessToken(_code, _feature)
                  .then((response) ->
                    view.hasAuthorized = true
                    _refresh_token = response.data?.refresh_token
                    access_token = response.data?.access_token
                    _GoogleInstance.getProfileIds(access_token).then((success) ->
                      view.loading = false
                      view.profiles = success.data?.items
                      if view.profiles.length is 0
                        notification.error("Error.", "The account you selected does not have access to this Google #{_feature} profile. Please make sure that the user you are re-authorizing your Google #{_feature} connection with has the appropriate permissions to access this account. For further assistance, please contact support.", "global")
                    ,(error) ->
                      _handleError('Error occurred while retrieving profile information.')
                    )
                  , (error) ->
                    _handleError('Error occurred while authenticating Google Account'))
              else
                view.loading = false
          ,(error) -> 
            _handleError('Error loading connections info')
          )

        return view
    ]
]
